<div class="benefits-new">
    <div class="benefits-new__inner">
        <mat-accordion>
            <mat-expansion-panel *ngFor="let content of block.content trackBy: trackByFn; first as isFirst" [expanded]="true" [disabled]="isDrawDisabled">
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                    <mat-panel-title>
                        <ng-container *ngIf="content.data.images[0].length > 1">
                            <div class="benefits-new__images">
                                <img *ngFor="let image of content.data.images; trackBy: trackByFn;" class="benefits-new__image" [src]="image" alt="" />
                            </div>
                        </ng-container>
                        <h3 class="benefits-new__header">{{content.data.headerText}}</h3>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="benefits-new__content" [innerHTML]="content.data.text"></div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
